export interface UploadIds {
  studyId?: number;
  interventionId?: number;
  moduleId?: number;
}

export enum UploadKeys {
  UPLOAD_FROM_STUDY = 'upload-from-study',
  UPLOAD_FROM_INTERVENTION = 'upload-from-intervention',
  UPLOAD_FROM_SUBSCRIPTION = 'upload-from-subscription',
  UPLOAD_FROM_INFORMATIVE_PAGE = 'upload-from-informative-page',
  UPLOAD_FROM_MODULE = 'upload-from-module',
  UPLOAD_FROM_MODULE_ITEM = 'upload-from-module-item',
  UPLOAD_FROM_TEMPLATE = 'upload-from-template',
}
